import { createFileRoute, useSearch } from '@tanstack/react-router';
import { SignIn } from '@clerk/clerk-react';

export const Route = createFileRoute('/sign-in/$')({
  component: SignInPage,
  validateSearch: (search: Record<string, unknown>) => ({
    redirect_url: (search.redirect_url as string) || undefined,
  }),
});

function SignInPage() {
  const { redirect_url } = useSearch({ from: '/sign-in/$' });

  // If redirect_url is external (different origin), use it as forceRedirectUrl
  // Clerk will handle the redirect after successful sign-in
  const isExternalRedirect =
    redirect_url?.startsWith('http') &&
    !redirect_url?.includes('landing.app.banqora.com');

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '100vh',
        paddingTop: 'clamp(2rem, 10vw, 5rem)',
        width: '100%',
      }}
    >
      <SignIn
        forceRedirectUrl={isExternalRedirect ? redirect_url : undefined}
        fallbackRedirectUrl="/"
      />
    </div>
  );
}
